/**
 * KpiStrip — 2x2 / 4-column grid of headline KPI tiles displayed above each
 * calculator's results block. Matches the summary tile bar at the top of
 * `docs/calc-references/*.html` results sections.
 */
export interface KpiTile {
  label: string;
  value: string | number;
  unit?: string;
}

export function KpiStrip({ tiles }: { tiles: KpiTile[] }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 my-4">
      {tiles.map((k, i) => (
        <div
          key={i}
          className="rounded-lg border border-slate-200 bg-white px-4 py-3"
        >
          <div className="text-xs uppercase tracking-wide text-slate-500">
            {k.label}
          </div>
          <div className="mt-1 text-xl font-semibold text-slate-900">
            {k.value}
            {k.unit && (
              <span className="ml-1 text-xs font-normal text-slate-500">
                {k.unit}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
